var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 10.882C11.4286 11.0119 11.1948 11.0638 10.987 11.0638C10.7792 11.0638 10.5455 11.0119 10.3377 10.882L0 4.57031V12.9599C0 14.7521 1.45455 16.2067 3.24675 16.2067H18.7532C20.5455 16.2067 22 14.7521 22 12.9599V4.57031L11.6364 10.882Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7509 0H3.24442C1.71195 0 0.413251 1.09091 0.101562 2.54545L11.0107 9.19481L21.8938 2.54545C21.5821 1.09091 20.2834 0 18.7509 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.6d5c9195fc9670bbe61c165b051a2e16.svg";
export { ForwardRef as ReactComponent };